

// ── Icons ─────────────────────────────────────────────────────────────────────
export const Icons = {
  Plus:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} width={18} height={18}><path d="M12 5v14M5 12h14"/></svg>,
  X:       () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} width={16} height={16}><path d="M18 6 6 18M6 6l12 12"/></svg>,
  Edit:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={15} height={15}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Check:   () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} width={15} height={15}><polyline points="20 6 9 17 4 12"/></svg>,
  Report:  () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={18} height={18}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  Filter:  () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={16} height={16}><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>,
  Search:  () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={16} height={16}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  Back:    () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={18} height={18}><polyline points="15 18 9 12 15 6"/></svg>,
  Refresh: () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={16} height={16}><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>,
  Circle:  () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} width={15} height={15}><circle cx="12" cy="12" r="9"/></svg>,
};

// ── Sheet Modal ───────────────────────────────────────────────────────────────
export function Sheet({ title, onClose, children, footer }) {
  return (
    <div
      style={overlay}
      onMouseDown={e => { if (e.target === e.currentTarget) e.currentTarget._close = true; }}
      onMouseUp={e => { if (e.currentTarget._close && e.target === e.currentTarget) { e.currentTarget._close = false; onClose(); } }}
    >
      <div style={sheet} onClick={e => e.stopPropagation()}>
        <div style={sheetHead}>
          <span style={{ fontSize: 16, fontWeight: 700 }}>{title}</span>
          <button onClick={onClose} style={iconBtn}><Icons.X /></button>
        </div>
        <div style={sheetBody}>{children}</div>
        {footer && <div style={sheetFoot}>{footer}</div>}
      </div>
    </div>
  );
}

// ── Form Fields ───────────────────────────────────────────────────────────────
export function Field({ label, children }) {
  return (
    <div>
      <div style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4 }}>{label}</div>
      {children}
    </div>
  );
}

export function Input({ ...props }) {
  return <input style={inputStyle} {...props} />;
}

export function Textarea({ ...props }) {
  return <textarea style={{ ...inputStyle, resize: 'vertical' }} {...props} />;
}

export function Select({ children, ...props }) {
  return <select style={inputStyle} {...props}>{children}</select>;
}

// ── Assignee Chips ────────────────────────────────────────────────────────────
export function AssigneeChips({ team, selected, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {team.map(name => (
        <button
          key={name}
          onClick={() => onChange(selected.includes(name) ? selected.filter(a => a !== name) : [...selected, name])}
          style={{
            background: selected.includes(name) ? '#dbeafe' : '#f1f5f9',
            border: `1px solid ${selected.includes(name) ? '#93c5fd' : '#e2e8f0'}`,
            color: selected.includes(name) ? '#1d4ed8' : '#475569',
            borderRadius: 20, padding: '5px 12px', fontSize: 13, cursor: 'pointer', fontWeight: 500,
          }}
        >{name}</button>
      ))}
    </div>
  );
}

// ── Buttons ───────────────────────────────────────────────────────────────────
export function PrimaryBtn({ children, onClick, disabled, style }) {
  return (
    <button onClick={onClick} disabled={disabled} style={{ background: '#3b82f6', border: 'none', color: '#fff', borderRadius: 8, padding: '10px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 14, flex: 1, opacity: disabled ? 0.6 : 1, ...style }}>
      {children}
    </button>
  );
}

export function GhostBtn({ children, onClick }) {
  return (
    <button onClick={onClick} style={{ background: '#f1f5f9', border: 'none', color: '#475569', borderRadius: 8, padding: '10px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
      {children}
    </button>
  );
}

export function IconBtn({ children, onClick, color, title }) {
  return (
    <button onClick={onClick} title={title} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: color || '#94a3b8', padding: 4, borderRadius: 4, display: 'flex', alignItems: 'center' }}>
      {children}
    </button>
  );
}

// ── Spinner ───────────────────────────────────────────────────────────────────
export function Spinner() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', flexDirection: 'column', gap: 12, color: '#64748b' }}>
      <div style={{ width: 32, height: 32, border: '3px solid #e2e8f0', borderTopColor: '#3b82f6', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

// ── Avatar Chip ───────────────────────────────────────────────────────────────
export function AvatarChip({ name }) {
  return <span style={{ background: '#e0f2fe', color: '#0369a1', fontSize: 11, fontWeight: 600, padding: '2px 7px', borderRadius: 10 }}>{name}</span>;
}

// ── Styles ────────────────────────────────────────────────────────────────────
const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 100 };
const sheet = { background: '#fff', borderRadius: '16px 16px 0 0', width: '100%', maxWidth: 640, maxHeight: '92vh', display: 'flex', flexDirection: 'column' };
const sheetHead = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 16px 12px', borderBottom: '1px solid #f1f5f9' };
const sheetBody = { overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 12 };
const sheetFoot = { display: 'flex', gap: 8, padding: '12px 16px', borderTop: '1px solid #f1f5f9' };
const iconBtn = { background: 'transparent', border: 'none', cursor: 'pointer', color: '#64748b', display: 'flex', padding: 4 };
export const inputStyle = { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '10px 12px', fontSize: 14, color: '#0f172a', outline: 'none', width: '100%', fontFamily: 'inherit', boxSizing: 'border-box' };
